// Main load function
//

import { resolveLocale } from './Helpers/Locale.js';

window.mainLoad = mainLoad;
export async function mainLoad(root = document.body) {
	const bp = window.breakpoint;

	// Scroll Animation
	//

	if ($('body').hasClass('scroll-animation')) {
		const { ScrollAnimation } = await import('./Classes/ScrollAnimation.js');
		const scrollAnimationInstance = new ScrollAnimation($('body.scroll-animation'), $('#headermedia'));

		// Re-initialize/update on breakpoint change so SCSS variables are re-evaluated
		$(window).on('breakpoint:change', function (e, bp, prev) {
			if (typeof scrollAnimationInstance !== 'undefined' && typeof scrollAnimationInstance.onResize === 'function') {
				// onResize already refreshes CssCalc, reads config and syncs with scroll
				scrollAnimationInstance.onResize();
			}
		});
	}


	// Initialize calendar (flatpickr)
	//

	const initCalendar = async (elements, root) => {
		if (typeof elements !== 'undefined' && elements.length) {
			try {
				const [{ Flatpickr }, { Formatter }] = await Promise.all([
					import('./Helpers/Flatpickr.js'),
					import('./Helpers/Formatter.js'),
				]);

				await Flatpickr.initOnElements(elements, (elem) => {
					const $el = $(elem);

					const isInFancybox = $el.closest('.fancybox__container, .fancybox__slide, .gn-fancybox').length > 0;
					let fancyboxRangeConfig = isInFancybox ? { static: true } : {};

					if ($el.closest('.availability-search-form').length > 0) {
						fancyboxRangeConfig = $el.hasClass('rangepicker') && isInFancybox
							? {
								...fancyboxRangeConfig,
								breakpoint: {
									641: {
										showMonths: 1,
									},
									711: {
										showMonths: 2,
									},
								},
							}
							: fancyboxRangeConfig;
					}

					if ($el.hasClass('availability')) {
						// return {};

						// Day infos (for availability) only for test purpose
						let parsedDayInfos = [];
						if($('#daily_min_price').length > 0) {
							try {
								parsedDayInfos = JSON.parse($('#daily_min_price').html());
							} catch(e) {
								parsedDayInfos = [];
							}
						}

						let dayInfos = new Map(parsedDayInfos);

						// Period infos
						let parsedPeriodInfos = [];
						if($('#calendar_seasons').length > 0) {
							try {
								parsedPeriodInfos = JSON.parse($('#calendar_seasons').html());
							} catch(e) {
								parsedPeriodInfos = [];
							}
						}

						// Select language
						for (const [k, p] of Object.entries(parsedPeriodInfos)) {
							if(typeof p.value.tooltip !== 'undefined' && typeof p.value.tooltip[la] !== 'undefined') {
								parsedPeriodInfos[k].value.tooltip = p.value.tooltip[la];
							}
						}
						let periodInfos = parsedPeriodInfos;

						// Merge day & period infos
						let dateInfos = [
							...Array.from(dayInfos.entries()).map(([date, value]) => ({ from: date, to: date, value })),
							...periodInfos
						];

						return {
							...fancyboxRangeConfig,

							// After functions extending the existing onFunctions instead of override
							// to keep base functions
							//

							onDayCreate: (dObj, dStr, fp, dayElem) => {
								if (!dayElem.querySelector('.day-item.day')) {
									const daySpan = document.createElement('span');
									daySpan.className = 'day-item day';
									daySpan.textContent = dayElem.textContent;
									dayElem.textContent = '';
									dayElem.appendChild(daySpan);
								}

								try {
									// Find all matching infos (single days and periods) for this day
									const d = typeof fp !== 'undefined' && typeof fp.parseDate === 'function' ? fp.parseDate(dayElem.dateObj, 'Y-m-d') : new Date(dayElem.dateObj);
									d.setHours(0,0,0,0);
									const matchingPeriods = [];
									for (const p of dateInfos) {
										const from = typeof fp !== 'undefined' && typeof fp.parseDate === 'function' ? fp.parseDate(p.from, 'Y-m-d') : new Date(p.from);
										const to = typeof fp !== 'undefined' && typeof fp.parseDate === 'function' ? fp.parseDate(p.to, 'Y-m-d') : new Date(p.to);
										if (from && to) {
											from.setHours(0,0,0,0);
											to.setHours(0,0,0,0);
											if (d >= from && d <= to) {
												matchingPeriods.push({ ...p.value, from: p.from, to: p.to });
											}
										}
									}

									let price = '-';

									for (const p of matchingPeriods) {
										// Adding class
										if (typeof p.class !== 'undefined') {
											if(typeof p.class === 'string') {
												dayElem.classList.add(p.class);
											}
											if(typeof p.class === 'object') {
												for (const [index, classItem] of Object.entries(p.class)) {
													dayElem.classList.add(classItem);
												}
											}
										}

										// Tooltip
										if (typeof p.tooltip !== 'undefined') {
											Object.assign(dayElem.dataset, {
												bsToggle: 'tooltip',
												bsPlacement: 'top',
												bsTitle: p.tooltip,
												bsTrigger: 'hover',
											});

											try {
												if (window.bootstrap && window.bootstrap.Tooltip) {
													if (typeof window.bootstrap.Tooltip.getOrCreateInstance === 'function') {
														window.bootstrap.Tooltip.getOrCreateInstance(dayElem, { container: '.availability-search-form' });
													} else {
														var existing = typeof window.bootstrap.Tooltip.getInstance === 'function' ? window.bootstrap.Tooltip.getInstance(dayElem) : null;
														if (!existing) {
															new window.bootstrap.Tooltip(dayElem, { container: '.availability-search-form' });
														}
													}
												}
											} catch (e) {
												/* ignore tooltip init errors */
											}
										}

										// Adding price (once, last one)
										if (typeof p.price !== 'undefined') {
											price = Formatter.formatPrice(p.price, true);
										}
									}

									if (!dayElem.querySelector('.day-item.price') && typeof parsedDayInfos !== 'undefined' && parsedDayInfos.length > 0) {
										const priceSpan = document.createElement('span');
										priceSpan.className = 'day-item price';
										priceSpan.textContent = price;
										dayElem.appendChild(priceSpan);
									}

									dayElem.addEventListener('click', function () {
										try {
											if (typeof window.bootstrap !== 'undefined' && typeof window.bootstrap.Tooltip !== 'undefined') {
												var container = (fp && fp.calendarContainer) ? fp.calendarContainer : document;
												var nodes = container.querySelectorAll('[data-bs-toggle="tooltip"]');
												nodes.forEach(function (el) {
													var inst = (typeof window.bootstrap.Tooltip.getInstance === 'function')
														? window.bootstrap.Tooltip.getInstance(el)
														: (typeof window.bootstrap.Tooltip.getOrCreateInstance === 'function'
															? window.bootstrap.Tooltip.getOrCreateInstance(el, {
																container: 'body',
																html: true,
															})
															: null);
													if (typeof inst !== 'undefined' && typeof inst.hide === 'function') {
														inst.hide();
													}
												});
											}
										} catch (e) {
											/* ignore tooltip hide errors */
										}
									});
								} catch (err) {
									console.warn('onDayCreate hook failed', err);
								}
							},
							onRangeUpdate: (instance, rangeInput, value) => {
								if (typeof Flatpickr.setValue === 'function' && strings && lang) {
									if (parseInt(value) == 1 && strings.night && strings.night[lang]) {
										value += ' ' + strings.night[lang];
									} else if (strings.nights && strings.nights[lang]) {
										value += ' ' + strings.nights[lang];
									}

									Flatpickr.setValue(rangeInput, value)
								}
							},
							afterValueUpdate: function(selectedDates, dateStr, instance) {
								if($('.availability-search-form .fp-no-dates').length > 0) {
									$('.availability-search-form .fp-no-dates').remove();
								}
							},
						};
					}
					return fancyboxRangeConfig;
				});
			} catch (e) {
				console.warn('Flatpickr failed to load', e);
			}
		}
	}

	const calendarItems = initCalendar($('.flatpickr', root));


	// Initialize noUiSlider
	//

	const rangeslider = root.querySelectorAll('.rangeslider');
	if (typeof rangeslider !== 'undefined' && rangeslider.length) {
		try {
			const valueMapping = {
				'stars': {
					1: '<span class="icon-star"></span>',
					2: '<span class="icon-group-star-2"></span>',
					3: '<span class="icon-group-star-3"></span>',
					4: '<span class="icon-group-star-3"></span>s',
					5: '<span class="icon-group-star-4"></span>',
					6: '<span class="icon-group-star-4"></span>s',
					7: '<span class="icon-group-star-5"></span>',
				},
				'flowers': {
					1: '<span class="icon-group-flowers-1"></span>',
					2: '<span class="icon-group-flowers-2"></span>',
					3: '<span class="icon-group-flowers-3"></span>',
					5: '<span class="icon-group-flowers-4"></span>',
				},
				'suns': {
					1: '<span class="icon-group-suns-1"></span>',
					2: '<span class="icon-group-suns-2"></span>',
					3: '<span class="icon-group-suns-3"></span>',
					5: '<span class="icon-group-suns-4"></span>',
				}
			}

			const { NoUiSlider } = await import('./Helpers/NoUiSlider.js');
			const { Formatter } = await import('./Helpers/Formatter.js');
			await NoUiSlider.initOnElements(rangeslider,
				(elem) => {
					const $el = $(elem);
					const type = $el.attr('data-type');
					return {
						keyboardSupport: true,
						keyboardMultiplier: type === 'price' ? 10 : 1,
						keyboardPageMultiplier: type === 'price' ? 50 : 5
					};
				}, (elem) => {
					const $el = $(elem);
					const type = $el.attr('data-type');
					if (type == "price") {
						return {
							valueFormatter: (n) => Formatter.formatPrice(n, true),
						}
					} else if (type == "stars" || type == "suns" || type == "flowers") {
						return {
							valueFormatter: (n) => {
								if (valueMapping && typeof valueMapping === 'object' && valueMapping[type] && typeof valueMapping[type] === 'object' && valueMapping[type][n]) {
									return valueMapping[type][n];
								}
								return n;
							}
						}
					}
					return {};
				});
		} catch (e) {
			// Fail silently if module cannot be loaded
		}
	}


	// Content Navigation
	// Scroll-Spy (support multiple instances)
	//

	const navs = root.querySelectorAll('.contentnav nav');
	if (typeof navs !== 'undefined' && navs.length) {
		const { ContentNavSpy } = await import('./Classes/ContentNavSpy.js');
		navs.forEach(nav => new ContentNavSpy(document, nav));
	}


	// Accordion
	//

	let Accordion;
	try {
		({ Accordion } = await import('./Classes/Accordion.js'));
		window.Accordion = Accordion;

		// Pre-check for accordions before initializing
		const hasGenericAccordions = $('.articleaccordion, .accordion-container', root).length > 0
			|| $('.articleaccordion .accordion-item, .accordion-container .accordion-item', root).length > 0;
		const hasBpAccordions = bp ? ($('.accordion-container-' + bp, root).length > 0
			|| $('.accordion-container-' + bp + ' .accordion-item', root).length > 0) : false;

		// Initial init for generic accordions (only if present)
		if (hasGenericAccordions) {
			Accordion.init($('.articleaccordion, .accordion-container', document));
		}
		// Initial init for current breakpoint-specific containers (only if present)
		if (bp && hasBpAccordions) {
			Accordion.init('.accordion-container-' + bp);
		}
		// Handle reinitialization on breakpoint changes
		let lastAppliedBreakpoint = window.breakpoint;
		let resizeTimer;
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				// detectBreakpoint() is called elsewhere and updates window.breakpoint
				const current = window.breakpoint;
				if (!current) return;
				if (current !== lastAppliedBreakpoint) {
					const list = (window.breakpoints && Array.isArray(window.breakpoints)) ? window.breakpoints : ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
					list.forEach(function (bpName) {
						if (bpName !== current) {
							Accordion.destroy('.accordion-container-' + bpName);
						}
					});
					// Only init if there are containers for the new breakpoint
					const hasCurrentBp = $('.accordion-container-' + current, document).length > 0
						|| $('.accordion-container-' + current + ' .accordion-item', document).length > 0;
					if (hasCurrentBp) {
						Accordion.init('.accordion-container-' + current);
						lastAppliedBreakpoint = current;
					} else {
						lastAppliedBreakpoint = current;
					}
				}
			}, 150);
		});
	} catch (e) {
		// Fail silently if module cannot be loaded
	}


	// Fancybox
	//

	const initFancybox = (box = root) => {
		if (typeof Fancybox !== 'undefined') {
			const resolveParentEl = (instance) => {
				const triggerEl = instance.getOptions().triggerEl;
				if (!triggerEl) return document.body;

				let parentEl =
					triggerEl.closest('.fancybox-container') ||
					(triggerEl.matches('.fancybox-container') ? el : null) ||
					document.body;

				const src = triggerEl.getAttribute('data-src');
				if (src && src.startsWith('#')) {
					const target = document.querySelector(src);
					if (target) {
						const targetContainer =
							target.closest('.fancybox-container') ||
							(target.matches('.fancybox-container') ? target : null);
						if (targetContainer) {
							parentEl = targetContainer;
						}
					}
				}

				return parentEl;
			};

			const locale = resolveLocale(['de', 'it']);
			const l10nMap = {
				de: Fancybox?.l10n?.de_DE,
				it: Fancybox?.l10n?.it_IT,
			};

			// Locking mechanism to prevent multiple instances
			let isOpening = false;

			const defaultSettings = {
				theme: "light",
				mainClass: "gn-fancybox backdrop-blur-16",
				parentEl: resolveParentEl,
				dragToClose: (instance) => {
					const slide = instance?.getSlide?.();
					return slide?.type !== 'html';
				},
				Carousel: {
					gestures: (ref) => {
						return (typeof ref?.getSlides === 'function' ? ref.getSlides().length : 0) > 1;
					},
					Thumbs: {
						type: 'classic',
					},
					Video: {
						autoplay: false,
					}
				},
				on: {
					// Release lock when lightbox is ready
					ready: (instance) => {
						isOpening = false;
					},
					// Release lock if closing or destroyed before ready (e.g. error or fast close)
					"Carousel.ready": function (instance) {
						isOpening = false;
						try {
							const slide = instance?.getSlide?.();
							const el = slide?.el;

							if (!el) {
								return;
							}

							// Remove f-html class on original for clone type
							//

							const triggerEl = instance?.getOptions?.()?.triggerEl;
							const isClone = triggerEl?.getAttribute?.('data-type') === 'clone';
							if (isClone && typeof slide?.src === 'string' && slide.src.startsWith('#')) {
								document.querySelector(slide.src)?.classList.remove('f-html');

								// Thumbnail-slider
								//

								import('./Helpers/SwiperCloneHelper.js').then(({ SwiperCloneHelper }) => {
									SwiperCloneHelper.reset(el);

									if (typeof window.initThumbnailSlider === 'function') {
										$('.thumbnail-slider', el).each(function () {
											window.initThumbnailSlider($(this));
										});
									}
								});
							}

							// Add scroll event listener
							//

							el.addEventListener('scroll', function (e) {
								const scrollPosition = $(el).scrollTop();
								$(el).css('--scroll-position', `${scrollPosition}px`);
							});

							// Set custom trigger
							//

							const htmlEl = slide?.htmlEl;
							if (htmlEl) {
								$(htmlEl).trigger('fancybox:ready');
							}

							// Additional close button
							//

							el.querySelectorAll('.fb-close').forEach(function (closeBtn) {
								closeBtn.addEventListener('click', function (e) {
									e.preventDefault();
									instance.close();
								});
							});

							// Blazy revalidate
							//

							if (typeof window.bLazy?.revalidate === 'function') {
								window.bLazy.revalidate();
							}

							// Init calendar (flatpickr)
							//

							const calendarItems = initCalendar($('.flatpickr', el));

							// Init fancybox
							//

							initFancybox(el);
						} catch (e) {
							//console.warn('Fancybox ready hook failed', e);
						}
					},
					"Carousel.destroy": function (instance) {
						// Release lock
						isOpening = false;

						try {
							const slide = instance?.getSlide?.();

							if (typeof slide?.src === 'string' && slide.src.startsWith('#')) {
								document.querySelector(slide.src)?.classList.remove('f-html');
							}

							const htmlEl = slide?.htmlEl;
							if (htmlEl) {
								htmlEl.classList.remove('f-html');
							}
						} catch (e) {
							//console.warn('Fancybox destroy hook failed', e);
						}
					},
					click: (instance, event) => {
						// Prevent opening if another one is currently opening
						if (isOpening) {
							event.preventDefault();
							event.stopPropagation();
							return false;
						}
						isOpening = true;
					},
				},
				l10n: l10nMap[locale],
			}

			const fancybox = box.querySelectorAll('[rel^=lightbox], [data-fancybox]:not([data-type="ajax-json"]), .fancybox, .lightbox');
			if (typeof fancybox !== 'undefined' && fancybox.length) {
				const settings = {
					...defaultSettings,
				};
				Fancybox.bind(fancybox, settings);
			}

			const fancyboxiFrame = box.querySelectorAll('.fancybox-iframe');
			if (typeof fancyboxiFrame !== 'undefined' && fancyboxiFrame.length) {
				fancyboxiFrame.forEach(function (el) {
					el.addEventListener('click', async (e) => {
						e.preventDefault();

						if (isOpening) {
							return;
						}

						const src = el.getAttribute("data-src") || el.getAttribute("href");
						if (!src) return;

						isOpening = true;

						const settings = {
							...defaultSettings,
						}

						Fancybox.show(
							[{
								type: "iframe",
								src: src
							}],
							settings,
						);
					});
				});
			}

			// Ajax json fancybox
			const ajaxJsonFancybox = box.querySelectorAll('[data-fancybox][data-type="ajax-json"]');
			if (typeof ajaxJsonFancybox !== 'undefined' && ajaxJsonFancybox.length) {
				ajaxJsonFancybox.forEach(function (el) {
					el.addEventListener('click', async (e) => {
						e.preventDefault();

						if (isOpening) {
							return;
						}

						const url = el.getAttribute("data-src") || el.getAttribute("href");
						if (!url) return;

						isOpening = true;

						try {
							const res = await fetch(url, {
								mode: 'cors', // no-cors, *cors, same-origin
								credentials: 'include', // include, *same-origin, omit
								redirect: 'follow', // manual, *follow, error
								referrerPolicy: 'no-referrer-when-downgrade', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
								headers: {
									Accept: "application/json"
								}
							});
							if (!res.ok) throw new Error(`HTTP ${res.status}`);

							const data = await res.json();

							if (!data.html) {
								isOpening = false;
								return;
							}
							const html = data.html;

							// optional: Loading direkt öffnen
							// Store InlineDetachMover instances for cleanup
							let detachMoverInstances = [];

							const settings = {
								...defaultSettings,
								on: {
									...defaultSettings.on,
									"Carousel.ready": function (instance) {
										const slide = instance?.getSlide?.();
										const el = slide?.el;

										if (!el) {
											return;
										}


										// Add scroll event listener
										//

										el.addEventListener('scroll', function (e) {
											const scrollPosition = $(el).scrollTop();
											$(el).css('--scroll-position', `${scrollPosition}px`);
										});


										// Set custom trigger
										//

										const htmlEl = slide?.htmlEl;
										if (htmlEl) {
											$(htmlEl).trigger('fancybox:ready');
										}

										// Additional close button
										//

										el.querySelectorAll('.fb-close').forEach(function (closeBtn) {
											closeBtn.addEventListener('click', function (e) {
												e.preventDefault();
												instance.close();
											});
										});

										// Detach page content
										//
										const detachElements = el.querySelectorAll('[data-detatch-mover], .detatch-mover');
										if (typeof detachElements !== 'undefined' && detachElements.length) {
											(async () => {
												try {
													const { InlineDetachMover } = await import('./Classes/InlineDetachMover.js');
													detachMoverInstances = InlineDetachMover.bind(detachElements, {sourceContext: document.body});
												} catch (e) {
													// Fail silently if module cannot be loaded
													console.warn('InlineDetachMover failed to load', e);
												}
											})();
										}

										// Blazy revalidate
										//

										if (typeof window.bLazy?.revalidate === 'function') {
											window.bLazy.revalidate();

											// @todo: not so ideal, but also a new instance is'n it
											el.addEventListener('scroll', function () {
												window.bLazy.revalidate();
											});

											el.querySelectorAll('.scrollcontainer').forEach(function (elem) {
												elem.addEventListener('scroll', function () {
													if (typeof window.bLazy?.revalidate === 'function') {
														window.bLazy.revalidate();
													}
												}, passiveSupport() ? { passive: true } : false);
											});
										}

										// Init/open accordion
										//

										if (typeof Accordion !== 'undefined' && Accordion && container) {
											const accordion = $(el).find('.articleaccordion, .accordion-container, [class*="accordion-container-"]');

											const uninitializedAccordions = accordion.filter(function () {
												return $(this).find('.accordion-item:not(.accordion-initialized)').length > 0;
											});
											if (typeof uninitializedAccordions !== 'undefined' && uninitializedAccordions.length) {
												Accordion.init(uninitializedAccordions, true);
											}
										}

										// Init calendar (flatpickr)
										//

										const calendarItems = initCalendar($('.flatpickr', el));

										// Init tabs
										//

										if ($('.tabs-container', el).length > 0 && typeof initTabs !== 'undefined' && initTabs) {
											initTabs($('.tabs-container', el));

											// Init tab navigation slider

											if ($('.tabs-navigation:has(.swiper-container)', el).length > 0 && typeof initTabNavigationSlider !== 'undefined' && initTabNavigationSlider) {
												$('.tabs-navigation:has(.swiper-container)', el).each(function () {
													initTabNavigationSlider($(this));
												})
											}
										}

										// Init slider gallery
										//

										const gallery = $('.articlegallery');
										if (typeof gallery !== 'undefined' && gallery.length && typeof getGalleryMode === 'function' && typeof initSliderGallery === 'function' && typeof destroySliderGallery === 'function') {
											$(gallery).each(function () {
												const elem = $(this);
												const mode = getGalleryMode(elem, bp);

												if (mode == 'slider') {
													initSliderGallery(elem);
												}

												if (typeof prev !== 'undefined') {
													const prevMode = getGalleryMode(elem, prev);
													if (mode != 'slider' && mode != prevMode) {
														destroySliderGallery(elem);
													}
												}
											});
										}


										// search for javascripts in modal and execute them
										const scripts = $(el).get(0).querySelectorAll('script');
										scripts.forEach((oldScript) => {
											const newScript = document.createElement('script');
											Array.from(oldScript.attributes).forEach((attr) => {
												newScript.setAttribute(attr.name, attr.value);
											});
											newScript.appendChild(document.createTextNode(oldScript.innerHTML));
											oldScript.parentNode.replaceChild(newScript, oldScript);
										});

										// Release lock if it was ajax-json opening
										isOpening = false;

										// Init fancybox
										//

										initFancybox(el);
									},
									"Carousel.destroy": function (instance) {
										// Restore detached instances
										//
										if (detachMoverInstances && detachMoverInstances.length) {
											detachMoverInstances.forEach(moverInstance => {
												if (moverInstance && typeof moverInstance.destroy === 'function') {
													moverInstance.destroy();
												}
											});
											detachMoverInstances = [];
										}
									}
								}
							};

							Fancybox.show(
								[{
									type: "html",
									html: html
								}],
								settings,
							);
						} catch (e) {
							// Fail silently
							console.warn('Error loading json data for fancybox', e);
							isOpening = false;
						}
					});
				});
			}
		}
	}

	initFancybox(root);


	// Tooltip
	//
	const tooltipTriggerList = root.querySelectorAll('[data-bs-toggle="tooltip"]');
	if (typeof tooltipTriggerList !== 'undefined' && tooltipTriggerList.length) {
		// Initialize Bootstrap tooltip if available (defensive, no-op if Bootstrap JS not loaded)
		try {
			if (typeof window.bootstrap !== 'undefined' && typeof window.bootstrap.Tooltip !== 'undefined') {
				const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl, {
					html: true,
					delay: {
						show: 300,
						hide: 0
					}
				}));
			}
		} catch (e) {
			/* ignore tooltip init errors */
		}
	}


	// Popover
	//
	const popoverTriggerList = root.querySelectorAll('[data-bs-toggle="popover"]');
	if (typeof popoverTriggerList !== 'undefined' && popoverTriggerList.length) {
		// Initialize Bootstrap popover if available (defensive, no-op if Bootstrap JS not loaded)
		try {
			if (typeof window.bootstrap !== 'undefined' && typeof window.bootstrap.Popover !== 'undefined') {
				const popoverList = [...popoverTriggerList].forEach((el) => {
					const containerEl = el.closest('.fullscreen') || 'body';
					new window.bootstrap.Popover(el, {
						html: true,
						delay: {
							show: 300,
							hide: 0
						},
						container: containerEl,
						template: '<div class="popover" role="tooltip">' +
							'	<div class="popover-arrow"></div>' +
							'	<strong class="popover-header d-block"></strong>' +
							'	<div class="popover-body"></div>' +
							'</div>',
					});
				});
			}
		} catch (e) {
			/* ignore tooltip init errors */
		}
	}

	// Blazy revalidate
	if (typeof window.bLazy?.revalidate === 'function') {
		window.bLazy.revalidate();
	}


	// Search filter
	//

	const searchFilters = document.querySelectorAll('.searchfilter');
	if (typeof searchFilters !== 'undefined' && searchFilters.length) {
		const { SearchFilter } = await import('./Classes/SearchFilter.js');
		searchFilters.forEach(function(searchFilter) {
			SearchFilter.init(searchFilter);
		});
	}


	// Holiday planner account access
	//

	await updateHolidayPlannerAccountAccess(root);


	// Zoomable svg
	//

	const zoomableSvgs = document.querySelectorAll('.zoomable-svg');
	if (zoomableSvgs.length) {
		const { ZoomableSvg } = await import('./Classes/ZoomableSvg.js');
		zoomableSvgs.forEach(zoomableSvg => {
			new ZoomableSvg(zoomableSvg);
		});
	}


	// Sync text input
	const syncTextInput = root.querySelectorAll('input[type="text"][data-sync-input]');
	if (syncTextInput.length) {
		const { SyncTextInput } = await import('./Classes/SyncTextInput.js');
		syncTextInput.forEach(syncTextInput => {
			new SyncTextInput(syncTextInput);
		});
	}
}

window.updateHolidayPlannerAccountAccess = updateHolidayPlannerAccountAccess;
export async function updateHolidayPlannerAccountAccess(total = null, root = document.body) {
	const holidayPlannerAccountAccessItems = $('.holiday-planner-account-access', root);
	if (typeof holidayPlannerAccountAccessItems !== 'undefined' && holidayPlannerAccountAccessItems.length) {
		const { HolidayPlanner } = await import('./Classes/HolidayPlanner.js');
		HolidayPlanner.updateHolidayPlannerAccountAccess(holidayPlannerAccountAccessItems, total);
	}
}

$(function () {
	void mainLoad();
});

// General async function
//

$(async function () {
	/*
	// Easter Egg
	// quick up-down scroll to fly SVG across the screen
	//

	try {
		await import('./Easter-egg.js');
	} catch (e) {
		// Fail silently if module cannot be loaded
	}
	*/
});
